<template>
    <div :class="clContainer()">
        <div :class="clSub('stars')">
            <div v-for="index in 5" :key="index" :class="clSub('star')">
                <img v-if="index <= stars" :src="getIconSrc('star-full.svg')" :style="starStyle" />
                <img v-else :src="getIconSrc('star-empty.svg')" :style="starStyle" />

                <div v-if="useAverage && index - 1 === parseInt(averageRating) && averageRatingLastPortion > 0" 
                    :class="clSub('star-portion')"
                    :style="{ width: (averageRatingLastPortion * 100) + '%' }">
                    
                    <img :src="getIconSrc('star-full.svg')" :style="starStyle" />
                </div>
            </div>
        </div>

        <div v-for="(rating, index) in ratings" :key="index">
            <div v-if="showRatingKeyword" :class="clSub('rating-keyword')">
                {{ __('jobs.components.rating.display.labels.keyword') }}
                {{ __(`jobs.common.rating.rating_keywords.${rating.rating}`) }}
            </div>

            <div v-if="showTerms" :class="clSub('terms')">
                <div v-for="(term, index) in rating.terms" 
                    :key="index"
                    :class="clSub('term', 'btn btn-secondary btn-xsmall btn-auto-width mb-sm mr-xs')">
                    
                    {{ term }}
                </div>
            </div>

            <div v-if="showMessage && rating.message" :class="clSub('message')">
                {{ __('jobs.components.rating.display.labels.message') }} 
                <p v-html="rating.message"></p>
            </div>
        </div>
    </div>
</template>

<script>
import NeedsSetableCssClasses from '../Mixins/NeedsSetableCssClasses';
import NeedsIcons from '../Mixins/NeedsIcons';

export default {
    mixins: [ NeedsSetableCssClasses, NeedsIcons ],
    props: {
        rating: {
            type: Object | Array,
            required: true
        },
        useAverage: {
            type: Boolean,
            default: false
        },
        showRatingKeyword: {
            type: Boolean,
            default: true
        },
        showTerms: {
            type: Boolean,
            default: true
        },
        showMessage: {
            type: Boolean,
            default: true
        },
        baseClass: {
            type: String,
            default: 'job-rating-display'
        },
        starSize: {
            type: String,
            default: '24px'
        }
    },
    computed: {
        ratings() {
            return Array.isArray(this.rating) ? this.rating : [ this.rating ];
        },
        stars() {
            return this.useAverage ? this.averageRating : this.ratings[0].rating;
        },
        averageRating() {
            return this.ratings.reduce((ratingSum, rating) => ratingSum + rating.rating, 0) / this.ratings.length;
        },
        averageRatingLastPortion() {
            return this.averageRating - parseInt(this.averageRating);
        },
        starStyle() {
            return { width: this.starSize };
        }
    }
}
</script>

<style lang="scss">
.job-rating-display {
    &__stars {
        display: flex;
    }

    &__star {
        position: relative;

        img {
            max-width: none;
        }

        &-portion {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            overflow: hidden;
        }
    }
}
</style>